import CourseMap from './components/CourseMap'

export default CourseMap
